import React from "react";
import type { Editor } from "@tiptap/react";
import { Button } from "@/components/ui/button";
import { Bold, Italic, Underline, Highlighter } from "lucide-react";

interface TextFormattingGroupProps {
  editor: Editor;
  disabled: boolean;
  onToggleFormat: (format: string) => void;
}

export function TextFormattingGroup({ editor, disabled, onToggleFormat }: TextFormattingGroupProps) {
  return (
    <>
      <Button
        type="button"
        variant={editor.isActive("bold") ? "default" : "ghost"}
        size="sm"
        onClick={() => onToggleFormat("bold")}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title="Bold"
      >
        <Bold className="h-4 w-4" />
      </Button>

      <Button
        type="button"
        variant={editor.isActive("italic") ? "default" : "ghost"}
        size="sm"
        onClick={() => onToggleFormat("italic")}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title="Italic"
      >
        <Italic className="h-4 w-4" />
      </Button>

      <Button
        type="button"
        variant={editor.isActive("underline") ? "default" : "ghost"}
        size="sm"
        onClick={() => onToggleFormat("underline")}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title="Underline"
      >
        <Underline className="h-4 w-4" />
      </Button>

      <Button
        type="button"
        variant={editor.isActive("highlight") ? "default" : "ghost"}
        size="sm"
        onClick={() => onToggleFormat("highlight")}
        disabled={disabled}
        className="h-8 w-8 p-0 flex-shrink-0"
        title="Highlight"
      >
        <Highlighter className="h-4 w-4" />
      </Button>
    </>
  );
}
